import { Box, Flex } from '@chakra-ui/react';
import Head from 'next/head';
import React from 'react'
import { AuxiliaryBanner } from '../../components/Banner';
import { ProfessionalsCard } from '../../components/Landing';
import { professionals } from '../../data';
import { WrapperStyle } from '../../styles/newDesignStyles'
import { WhoWeHelpHeader, WhoWeHelpSemiHeader } from '../../styles/typography';

const WhoWeHelp = ({ professionals }) => {

    return (
        <>

            <Head>
                <title key="title">Who we help - Business and Commercial Real Estate Listings</title>
                <meta key="description" name="description" content="Zonado helps realtors, brokers, buyers, business owners, franchisors list their assetsand reach the right buyers directly. Add listing for free" />
                <meta key="og:title" property="og:title" content='Who we help - Business and Commercial Real Estate Listings' />
                <meta key="og:description" property="og:description" content="Zonado helps realtors, brokers, buyers, business owners, franchisors list their assetsand reach the right buyers directly. Add listing for free" />
                <link rel="canonical" href="https://zonado.com/who-we-help" />
            </Head>

            <WrapperStyle>
                <Box mt={{ base: "64px" }}>
                    <WhoWeHelpHeader text={"Built for those who mean business"} />
                    <WhoWeHelpSemiHeader text={"Zonado was built as a delightful escape from antique websites, broken processes, unauthentic listings, overpriced listing services with lack-luster support."} />
                </Box>

                <Flex my={{ md: "50px", lg: "70px" }} flexDir={{ base: "column", md: "row" }} justifyContent={"space-between"} flexWrap={"wrap"} width={"100%"}>
                    {
                        professionals.map(({ id, ...rest }) =>
                            <ProfessionalsCard
                                key={id}
                                whoweHelp
                                item={rest}
                            />
                        )
                    }
                </Flex>

                <AuxiliaryBanner
                    title={"Are you a service provider in the sale of business or commercial real estate industry? Let’s collaborate. "}
                    routeAction={"mailto:hello@zonado.com"}
                    body={"hello@zonado.com"}
                />

            </WrapperStyle>
        </>
    )
}

WhoWeHelp.newLayout = true;

export default WhoWeHelp

export async function getStaticProps() {
    return {
        props: { professionals },
    }
}